import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography
} from "@mui/material";
import DownloadPopup from "components/core/modal-components/DownloadPopup";
import CommonModal from "components/shared/common-modal/CommonModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  callToCloudFunction,
  getDataFromFirestore
} from "services/api/apiRequests";
import { CF_URLS } from "services/api/endpoints";
import { selectAuth } from "store/slices";
import spacing from "styles/spacing";
import {
  ALL_SELECTION,
  C,
  downloadOptionPdf,
  E,
  ERROR_TYPES,
  N_CHECKER,
  numberConstants,
  systemName,
  VALUE_EMPTY_STRING,
  Y_CHECKER
} from "utils/constants";
import {
  dataDogErrorLog,
  findErrorMessage,
  getUserName,
  handleRefId,
  printReport
} from "utils/helpers";
import { EmployeeSearchStyles } from "./EmployeeSearchStyles";
const EmployeeSearchPrintModal = ({
  isVisiblePrint,
  setIsVisiblePrint,
  employeeSearchForm,
  setLoading,
  getFilterBody
}) => {
  const { t } = useTranslation();
  const { currentBranch, auth } = useSelector(selectAuth);
  const [reportCUrl, setReportCFUrl] = useState(VALUE_EMPTY_STRING);
  const [selectedValue, setSelectedValue] = useState(downloadOptionPdf);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [throwError, setThrowError] = useState(false);
  const [throwErrorMessage, setThrowErrorMessage] = useState(false);

  const handleDownloadClose = () => {
    setIsDownloadModalOpen(false);
    setThrowError(false);
    setThrowErrorMessage(false);
    setReportCFUrl(VALUE_EMPTY_STRING);
  };

  const handleDownload = async () => {
    const { values } = employeeSearchForm;
    try {
      setLoading(true);
      const requestBody = JSON.stringify({
        main_district_id: currentBranch?.value,
        first_name: values?.firstName?.trim(),
        last_name: values?.lastName?.trim(),
        district_id_func:
          values?.district === ALL_SELECTION?.value
            ? numberConstants.zero
            : values?.district,
        job_title_id:
          values?.jobTitle === ALL_SELECTION?.value
            ? numberConstants.zero
            : values?.jobTitle,
        time_type_id: numberConstants.zero,
        cost_center_id: numberConstants.zero,
        emergency_contact_flag:
          values?.printType === t("employeeSearch.printEmergencyContact")
            ? Y_CHECKER
            : N_CHECKER,
        system_name: systemName,
        report_type:
          employeeSearchForm.values.printType ===
          t("employeeSearch.printEmergencyContact")
            ? E
            : C,
        operational_center_id:
          values?.defaultOperationalCenter === ALL_SELECTION?.value
            ? numberConstants.zero
            : values?.defaultOperationalCenter,
        work_center_id: numberConstants.zero,
        work_category_id: numberConstants.zero,
        supervisor_id: numberConstants.zero,
        user_name: getUserName(auth?.user),
        report_format: selectedValue?.type?.toUpperCase()
      });
      const isDataAvailable = await checkDataAvailable();
      if (!isDataAvailable) {
        setLoading(false);
        setThrowErrorMessage(t("reports.noDataFound"));
        setThrowError(true);
        return;
      }
      const url = CF_URLS.printReports.employeReports.employecontactreport;
      let reportResponse = await printReport(requestBody, url);
      if (!reportResponse?.success) {
        setThrowErrorMessage(reportResponse?.error);
        setThrowError(true);
      }
    } catch (e) {
      const { refId, message } = handleRefId(
        findErrorMessage(ERROR_TYPES.ISSUE)
      );
      dataDogErrorLog(
        message,
        CF_URLS.printReports.employeReports.employecontactreport,
        { error: e },
        refId
      );
      setThrowErrorMessage(message);
      setThrowError(true);
    } finally {
      setLoading(false);
    }
  };

  const handlePrintClose = () => {
    setIsVisiblePrint(false);
    employeeSearchForm.setFieldValue(
      "printType",
      t("employeeSearch.printEmergencyContact")
    );
  };

  const checkDataAvailable = async () => {
    const { values } = employeeSearchForm;
    let FilerBody = await getFilterBody(true);
    FilerBody = JSON.parse(FilerBody);
    FilerBody.emergency_contact_flag =
      values?.printType === t("employeeSearch.printEmergencyContact")
        ? Y_CHECKER
        : N_CHECKER;
    const response = await callToCloudFunction(
      JSON.stringify(FilerBody),
      CF_URLS.employeeSearch.getSearchValues
    );
    const data = await getDataFromFirestore(response, 1, response.data.docId);
    const employeeSearchResult = data.data[0];
    if (employeeSearchResult.length === 0) {
      return false;
    } else {
      return true;
    }
  };

  const handleOpenPrinterModal = async () => {
    setIsDownloadModalOpen(true);
    setReportCFUrl(CF_URLS.printReports.employeReports.employecontactreport);
  };
  return (
    <>
      <CommonModal
        open={isVisiblePrint}
        title={t("employeeSearch.printModalTitle")}
        body={
          <Grid container display={"flex"} direction={"column"}>
            <Grid item>
              <Typography>{t("common.printReportTitle")}</Typography>
            </Grid>
            <Grid item gap={spacing.horizontalMargin20}>
              <FormControl id="radio-control">
                <RadioGroup
                  id="radio-group"
                  name="printType"
                  column
                  aria-labelledby="Media Request Authorization Type"
                  value={employeeSearchForm.values.printType}
                  onChange={employeeSearchForm.handleChange}
                  sx={EmployeeSearchStyles.printModalRadio}
                >
                  <FormControlLabel
                    id="radio-form-control-1"
                    value={t("employeeSearch.printEmergencyContact")}
                    control={<Radio />}
                    label={t("employeeSearch.printRadioEmergencyContact")}
                  />

                  <FormControlLabel
                    id="radio-form-control-2"
                    value={t("employeeSearch.printContact")}
                    control={<Radio />}
                    label={t("employeeSearch.printRadioContact")}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        }
        buttons={
          <>
            <Button variant="outlined" onClick={handlePrintClose}>
              {t("common.close")}
            </Button>
            <Button variant="contained" onClick={handleOpenPrinterModal}>
              {t("common.print")}
            </Button>
          </>
        }
      ></CommonModal>

      <DownloadPopup
        title={t("common.downloadReport")}
        showPrintModal={isDownloadModalOpen}
        onCancleClick={handleDownloadClose}
        onDownloadClick={handleDownload}
        setSelectedValue={setSelectedValue}
        setThrowError={setThrowError}
        throwError={throwError}
        throwErrorMessage={throwErrorMessage}
        cfUrl={reportCUrl}
      />
    </>
  );
};

export default EmployeeSearchPrintModal;
